import {React,useState,useEffect} from 'react'
import '../../assets/style/clock.css'
const Clock = () => {

    const [days,setDays] = useState()
    const [hours,setHours] = useState()
    const [minutes,setMinutes] = useState()
    const [seconds,setSeconds] = useState()

    let interval;
    const countDown = ()=>{
        const destination = new Date('Mar 29, 2024').getTime()

        interval = setInterval(()=>{
            const now = new Date().getTime()
            const different = destination - now
            const days = Math.floor(different / (1000 * 60 * 60 *24))
            const hours = Math.floor(different % (1000 *60*60*24) / (1000*60*60))
            const minutes = Math.floor(different % (1000 * 60 * 60) / (1000*60))
            const seconds = Math.floor(different % (1000 *60) / 1000)
            if(destination < 0) clearInterval(interval.current)
            else{
                setDays(days)
                setHours(hours)
                setMinutes(minutes)
                setSeconds(seconds)
            }
        })
    }
    
    useEffect(()=>{
        countDown()
    })

    const easyCode = [
        {
            code:days,
            display:'Days'
        },
        {
            code:hours,
            display:'Hours'
        },
        {
            code:minutes,
            display:'Minutes'
        },
        {
            code:seconds,
            display:'Seconds'
        },
    ]

    return (
        <div className='clock__wrapper d-flex align-items-center gap-3'>
            {easyCode.map((time,index)=>{
                return(
                    <div key={index} className='clock__data d-flex align-items-center gap-3'>
                        <div className='text-center'>
                            <h1 className='text-white fs-3 mb-2'>{time.code} </h1>
                            <h5 className='text-white fs-6'>{time.display}</h5>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default Clock